import styled from "styled-components";

export const PageControl = styled.div`
  :not(:last-child) {
    margin-right: 40px;
  }
`;
